import { render, staticRenderFns } from "./PgaBottomNavigation.vue?vue&type=template&id=27ad1e8c&"
import script from "./PgaBottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./PgaBottomNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ad1e8c')) {
      api.createRecord('27ad1e8c', component.options)
    } else {
      api.reload('27ad1e8c', component.options)
    }
    module.hot.accept("./PgaBottomNavigation.vue?vue&type=template&id=27ad1e8c&", function () {
      api.rerender('27ad1e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Layout/PgaBottomNavigation.vue"
export default component.exports